export const cancelOrderReasonList = [
  {
    value: 1,
    label: '订单量较多，暂时无法接单',
  },
  {
    value: 2,
    label: '菜品已销售完，暂时无法接单',
  },
  {
    value: 3,
    label: '餐厅已打烊，暂时无法接单',
  },
  {
    value: 0,
    label: '自定义原因',
  },
]
export const cancelrReasonList = [
  {
    value: 1,
    label: '订单量较多，暂时无法接单',
  },
  {
    value: 2,
    label: '菜品已销售完，暂时无法接单',
  },
  {
    value: 3,
    label: '骑手不足无法配送',
  },
  {
    value: 4,
    label: '客户电话取消',
  },
  {
    value: 0,
    label: '自定义原因',
  },
]

export const orderList = [
  {
    label: '全部订单',
    value: 0,
  },
  {
    label: '待付款',
    value: 1,
  },
  {
    label: '待处理',
    value: 2,
  },
  {
    label: '待派送',
    value: 3,
  },
  {
    label: '派送中',
    value: 4,
  },
  {
    label: '已完成',
    value: 5,
  },
  {
    label: '已取消',
    value: 6,
  },
]
